<template>
  <div>
    <div class="tool-tip">
      <div class="tool-tip-tr" v-for="ev in alarmEvents" :key="ev.abbr">
        <div class="tool-tip-td">
          <div class="abbr" :class="ev.color ? 'badge-' + ev.color : 'badge-danger'" v-html="ev.abbr"></div>
        </div>
        <div class="text tool-tip-td">
          {{ ev.text }}
          <span v-if="showTotal(ev.total)">({{ ev.total }})</span>
        </div>
      </div>
      <div v-if="showMore" class="tool-tip-tr">
        <div class="tool-tip-td"></div>
        <div class="tool-tip-td text">{{ $t('src/components/eventstooltip.9741', { '1': more }) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventsConfig } from '@/events.config.js'
import('@/styles/components/tooltip.less')

export default {
  name: 'EventsToolTip',
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  computed: {
    alarmEvents() {
      let warningRes = [],
        dangerRes = [],
        activeArr = []
      this.events.forEach(event => {
        if (!Object.hasOwn(eventsConfig, event.episodeType))
          return

        activeArr = eventsConfig[event.episodeType].color === 'warning' ? warningRes : dangerRes
        let existEvent = activeArr.find(item => item.abbr === eventsConfig[event.episodeType].abbr)

        if (existEvent) {
          existEvent.total += 1
        } else {
          if (activeArr.length < 3) {
            activeArr.push({
              abbr: eventsConfig[event.episodeType].abbr,
              text: eventsConfig[event.episodeType].text,
              color: eventsConfig[event.episodeType].color,
              total: 1
            })
          }
        }
      })
      if (dangerRes.length < 3) {
        let countConcat = warningRes.length < 3 - dangerRes.length ? warningRes.length : 3 - dangerRes.length
        dangerRes = dangerRes.concat(warningRes.slice(0, countConcat))
      }
      return dangerRes
    },

    more() {
      let alarmEvents = this.alarmEvents
      let deduction = 0
      for (let i = 0; i < alarmEvents.length; i++) {
        deduction += alarmEvents[i].total
      }
      return this.events.length - deduction
    },

    showMore() {
      return this.more > 0
    }
  },
  methods: {
    showTotal(total) {
      return total > 1
    }
  }
}
</script>
